const profilesStrings = {
  updateProfileForm: {
    updateProfileFormTitle: 'Update Profile',
    updateProfileFormSubTitle: 'Enter profile info',
    updateProfileFormNameFieldPlaceholder: 'Name',
    updateProfileFormDescriptionFieldPlaceholder: 'Description',
    updateProfileFormLongDescriptionFieldPlaceholder: 'Long Description',
    updateProfileFormEmailFieldPlaceholder: 'Email',
    updateProfileFormWebsiteFieldPlaceholder: 'Website',
    updateProfileFormImageFieldPlaceholder: 'Profile Image',
    updateProfileFormSubmitBtn: 'SUBMIT',
    updateProfileFormSkipBtn: 'Skip',
    updateProfileFormSaveBtn: 'Save',
    updateProfileFormFieldErrorText(fieldName) {
      return `${fieldName} field must have a valid value`;
    },
    requestSuccessMessage: 'Data saved successfully',
    requestErrorMessage: 'Error happened, please try again',
    noSelectedCompany: 'You must select a company profile',
  },
};

export default profilesStrings;
